export enum Scope {
  AppContext = "AppContext",
  Experiments = "Experiments",
  Navigation = "Navigation",
  User = "User",
}
